<ds-modal
  [modal]="modal"
  [title]="(addFlag() ? 'add_flag_to_finding' : 'remove_flag_from_finding') | translate"
  [maxWidthPercentage]="60"
>
  <p>{{ (addFlag() ? 'add_flag_to_finding_details' : 'remove_flag_to_finding_details') | translate }}</p>
  <div [formGroup]="form">
    @if (addFlag()) {
      <ds-input
        [label]="'reason' | translate"
        [required]="true"
        [showRequiredAsterisk]="true"
        [errorState]="!!(flagReasonErrorMessage$ | async)"
        [errorMessage]="flagReasonErrorMessage$ | async"
        class="mb-3"
      >
        <select ds-input-field [formControlName]="FormFields.flagReason" style="max-width: none">
          <option [ngValue]="null" disabled>{{ 'select_an_option' | translate }}</option>
          @for (option of flagReasonOptions; track option) {
            <option [value]="option">{{ getFlagReasonTranslationKey(option) | translate }}</option>
          }
        </select>
      </ds-input>
    }
    <ds-input [label]="(addFlag() ? 'additional_note' : 'reason') | translate" [required]="false" class="mb-3">
      <textarea ds-input-field [formControlName]="FormFields.message" style="height: 200px; width: 100%"></textarea>
    </ds-input>
  </div>
  <div class="row">
    <div class="col-12 col-md-auto">
      <button ds-button [variant]="DsButtonVariants.primary" (click)="onFlagChange()">
        {{ (addFlag() ? 'add_flag' : 'remove_flag') | translate }}
      </button>
    </div>
    <div class="col-12 col-md-auto mt-3 mt-md-0 px-md-0">
      <button ds-button [variant]="DsButtonVariants.secondary" (click)="modalService.closeAllModals()">
        {{ 'label_cancel' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
